import { getRasterRotationOffset } from "../../../FloorPlanPanelWrapper/createDisplayTransform";
import type { GetRasterRotationStyle } from "./types";

export const getRasterRotationStyle: GetRasterRotationStyle = ({
  rotation,
  naturalWidth,
  naturalHeight,
}) => {
  if (rotation === 0) return undefined;
  const { translateX, translateY } = getRasterRotationOffset({
    rotation,
    width: naturalWidth,
    height: naturalHeight,
  });
  return {
    transform: `translate(${translateX}px, ${translateY}px) rotate(${rotation}deg)`,
    transformOrigin: "top left",
  };
};
